let index= {
  namespaced: 'index',
  state: {
    project: {}, // 项目
    userinfo: {}, // 用户信息
    batch: {}, // 卡断
    address: {},  // 地址
    report_authorize: null, // 是否授权
  },
  mutations: {
    setProject(state,params) {
      state.project = params
    },
    setUserInfo(state,params) {
      state.userInfo = params
    },
    setBatch(state,params) {
      state.batch = params.data
    },
    setAddress(state,params) {
      state.address = params
    },
    setReportAuthorize(state, params) {
      state.report_authorize = params
    }
  }
}
export default index


// WEBPACK FOOTER //
// ./src/store/modules/index.js